import { render, staticRenderFns } from "./CyberRiskAwarePricing.vue?vue&type=template&id=7247a0c2&"
import script from "./CyberRiskAwarePricing.vue?vue&type=script&lang=js&"
export * from "./CyberRiskAwarePricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports